import axios from '../../../utils/request';

function GET_ASEMALT() {
    return axios.get("/member/ASemalt/index" )
}

function SUBMIT_ADD(params) {
    return  axios.post("/member/ASemalt/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/member/ASemalt/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/member/ASemalt/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/member/ASemalt/statusEdit",{status:params} )
}

export default {
    GET_ASEMALT,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS

};